(() => {
  const init = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if ('IntersectionObserver' in window && !reduced) {
      root.dataset.revealReady = 'true';
      const reveal = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('state-brand-visible');
          entry.target.classList.remove('state-brand-entering');
          reveal.unobserve(entry.target);
        });
      }, { threshold: 0.06 });
      root.querySelectorAll('[data-state-reveal]').forEach(element => {
        if (element.getBoundingClientRect().top > window.innerHeight) {
          element.classList.add('state-brand-entering');
          reveal.observe(element);
        }
      });
    }
    const links = Array.from(root.querySelectorAll('.state-brand-jump a'));
    if ('IntersectionObserver' in window) {
      const active = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          links.forEach(link => {
            if (link.getAttribute('href') === '#' + entry.target.id) link.setAttribute('aria-current', 'location');
            else link.removeAttribute('aria-current');
          });
        });
      }, { rootMargin: '-25% 0px -55% 0px', threshold: 0 });
      links.forEach(link => { const target = root.querySelector(link.getAttribute('href')); if (target) active.observe(target); });
    }
    root.querySelectorAll('a[href^="#state-"]').forEach(link => {
      link.addEventListener('click', event => {
        const target = root.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: reduced ? 'instant' : 'smooth', block: 'start' });
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        history.replaceState(null, '', link.getAttribute('href'));
      });
    });
  };
  document.querySelectorAll('[data-state-brand]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-state-brand]').forEach(init));
})();
